// styles
import styles from "./styles.module.scss"

const Modal = ({ children, onClose }) => {

  return (
    <>
      <div className={styles.modalWindow}>
        {children}
      </div>
      <div className={styles.modalWindow__mask} onClick={onClose}></div>
    </>
  )
}

export default Modal
